// eslint-disable-next-line
export const ALLOWED_URI_REGEXP = /^(?:(?:https|http|mailto|tel|callto|zoomphonecall|zmdf|zoomus|cid):|(?:data:image\/)|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

// The default allowed tag list for DOMPurify@2.4.0 is
// https://github.com/cure53/DOMPurify/blob/5f8e875f4d01cffb8617d5999d9345417bdeb8bc/src/tags.js#L3
// These tags do not render in Gmail web or Office365 web.
// So we add them to FORBID_TAGS.
export const FORBID_TAGS = Object.freeze([
  'audio',
  'bdi',
  'blink',
  'canvas',
  'content',
  'data',
  'datalist',
  'decorator',
  'details',
  'dialog',
  'element',
  'hgroup',
  'main',
  'marquee',
  'menuitem',
  'meter',
  'nav',
  'nobr',
  'output',
  'picture',
  'progress',
  'rp',
  'rt',
  'ruby',
  'shadow',
  'source',
  'spacer',
  'summary',
  'svg', // ZOOM-496048
  'template',
  'track',
  'video',
]);

export const ADD_TAGS = Object.freeze(['meta']);

export const ADD_ATTR = Object.freeze(['target', 'charset']);

export const DEFAULT_MAIL_CONTENT_DOMPURIFY_CONFIG = {
  ALLOWED_URI_REGEXP,
  FORBID_TAGS,
  ADD_TAGS,
  ADD_ATTR,
  WHOLE_DOCUMENT: true,
};
